import { useTranslation } from "@i18n/hooks";
import { useUserRootNodesFilter } from "./user-root-nodes-filter.context";
import { DefaultTextFieldComponent } from "../../../../components/DefaultTextInput";

export const UserRootNodesFilter = () => {
	const { t } = useTranslation("common");
	const { filter, setFilter } = useUserRootNodesFilter();

	return (
		<DefaultTextFieldComponent
			fieldName="name"
			isValid={true}
			required={false}
			disabled={false}
			placeholder={t("userEdit.filterByName")}
			fieldValue={filter}
			updateField={setFilter}
		/>
	);
};
